import React, { useState } from 'react';
import { connect } from 'react-redux';
import TimePicker from 'components/common/timepicker'
import AutoSaveInput from 'components/common/autosaveinput'
import Modal from 'components/common/modal'
import { updateCard, deleteCard, addNodeToCard } from 'actions/defaultsettings'
import LocationPicker from "./LocationPicker"
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';
import config from 'config'

class Card extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			starthour: this.props.card.starthour,
			endhour: this.props.card.endhour
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.card.starthour != this.state.starthour || nextProps.card.endhour != this.state.endhour) {
			this.setState({
				starthour: nextProps.card.starthour,
				endhour: nextProps.card.endhour,
				weekdaymask: nextProps.card.weekdaymask
			});
		}
	}

	maskChecked(pos) {
		if (!this.props.card.weekdaymask) {
			return false;
		}
		return this.props.card.weekdaymask[pos] == "1";
	}

	changeHour(hours) {
		var newCard = {
			id: this.props.card.id,
			starthour: hours[0],
			endhour: hours[1] - 1
		};
		this.props.dispatch(updateCard(newCard));
	}

	replaceAt(s, index, replacement) {
		return s.substr(0, index) + replacement + s.substr(index + replacement.length);
	}

	changeWeekday(pos) {
		var newCard = {
			id: this.props.card.id,
			weekdaymask: this.replaceAt(this.props.card.weekdaymask, pos, (this.props.card.weekdaymask[pos] == "0") ? "1" : "0")
		};
		this.props.dispatch(updateCard(newCard));
	}

	deleteCard() {
		this.props.dispatch(deleteCard(this.props.card));
	}

	addNodeToCardfn(node, Card) {
		var card = Card;
		if (node.info.cardid == card.id) {
			card = this.props.defaultCard;
		}
		this.props.dispatch(addNodeToCard(node, card));
	}

	onSave(idKey, value) {
		if (idKey == "standbytime") {
			var newCard = {
				id: this.props.card.id,
				standbytime: value * 60
			};
			this.props.dispatch(updateCard(newCard));
		}
	}
	renderWeekdays() {
		let items = [...Array(7).keys()].slice(0).map(index => {
			var weekdays = new Array(7);
			weekdays[0] = "Sunday";
			weekdays[1] = "Monday";
			weekdays[2] = "Tuesday";
			weekdays[3] = "Wednesday";
			weekdays[4] = "Thursday";
			weekdays[5] = "Friday";
			weekdays[6] = "Saturday";
			return (
				<label className="text-center" key={index}>
					<input className="chbx" type="checkbox" checked={this.maskChecked(index)} onChange={this.changeWeekday.bind(this, index)} disabled={!this.props.editable} />
					<span className="custom-checkbox"></span><span className="week-day">{weekdays[index]}</span>
				</label>
			)
		})
		items.push(items.shift())
		return items
	}
	render() {
		var header = this.props.card.isdefault ? "Company Settings" : "Local Settings";
		var editable = this.props.editable;
		var deletable = editable && (this.props.card.isdefault == 0);

		return (
			<div className="default-settings-card box--shadow bg--white clearfix">
				<div className="card-heading clearfix">
					<h3 className="pull-left">{header}</h3>
					<LocationPicker
						root={this.props.root}
						card={this.props.card}
						disabled={this.props.disabled || !editable}
						defaultCard={this.props.defaultCard}
						handleChange={this.addNodeToCardfn.bind(this)}
					/>
				</div>
				<div className="working-hours">
					<h4>Working Hours</h4>
					<div className="hours-picker">
						<TimePicker
							disabled={!editable}
							nSegments={24}
							values={[this.props.card.starthour, this.props.card.endhour + 1]}
							onChange={this.changeHour.bind(this)}
						/>
					</div>
				</div>
				<div className="working-days" style={{ marginTop: 50 }}>
					<h4>Working Days</h4>
					<div className="days-picker clearfix">

						{this.renderWeekdays()}
					</div>
				</div>

				<div className="box-settings">
					<div className="box-settings__child display--flex__flex--center">
						<label>Stand By Time (minutes)</label>
						<AutoSaveInput
							className="input--minute"
							type="number"
							idKey="standbytime"
							value={Math.round(this.props.card.standbytime / 60)}
							style={{
								width: "60px", paddingLeft: 10,
								textAlign: "center"
							}}
							editable={editable}
							onSave={this.onSave.bind(this)}
						/>
					</div>
					{config.api.root === 'https://backend-dev.senzodata.com/api' &&
						<React.Fragment>
							<TimeInterval
								editable={editable}
								card={this.props.card}
							/>
							<OccupancyThreshold
								editable={editable}
								card={this.props.card}
							/>
						</React.Fragment>
					}
				</div>

				<div className="default-settings-bottom">
					<div className="pull-right">
						{deletable &&
							<Modal
								clickButton={this.deleteCard.bind(this)}
								header="Delete Card"
								buttonText="Delete"
								buttonClass="btn-danger"
								entry={
									<i data-tooltip="Delete" className="material-icons_size material-icons cursor--pointer red-500 pull-left">delete_forever</i>
								}
							>
								<p>Are you sure you want to delete this setting card ?</p>
							</Modal>
						}
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		me: state.myAccountReducer.user,
		nodeMap: state.overviewReducer.nodeMap
	};
}

function mapDispatchToProps(dispatch) {
	return {
		dispatch
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Card);

const TimeInterval = (props) => {
	//const dispatch = useDispatch();

	const [intervalVal, setIntervalVal] = useState(60)
	const { card, editable } = props

	function handleUpdateTimeInterval() {
		let newCard = {
			id: card.id,
			intervalVal: intervalVal
		};
		//dispatch(updateCard(newCard));
	}
	const intervalValueArr = [10, 30, 60, 86400]
	return (
		<div className="box-settings__child display--flex__flex--center">
			<label>Time Interval</label>
			<Dropdown
				noArrow={true}
				className="box-settings__child__dropdown"
				header={
					<React.Fragment>
						{intervalVal !== 86400 ? `${intervalVal} min` : "Full day"}
						<i className="material-icons">keyboard_arrow_down</i>
					</React.Fragment>
				}
				toggleable={editable}
			>
				{intervalValueArr.map(x => {
					return (
						<React.Fragment key={x}>
							<DropdownItem>
								<div onClick={() => {
									setIntervalVal(x);
									handleUpdateTimeInterval()
								}}>
									{x !== 86400 ? `${x} min` : "Full day"}
								</div>
							</DropdownItem>
						</React.Fragment>
					)
				})
				}
			</Dropdown>
		</div>
	)
}

const OccupancyThreshold = (props) => {
	//const dispatch = useDispatch();

	const [occupancyThreshold, setOccupancyThreshold] = useState(0)
	const { card, editable } = props

	function handleUpdateThreshold() {
		let newCard = {
			id: card.id,
			occupancyThreshold: occupancyThreshold
		};
		//dispatch(updateCard(newCard));
	}
	const thresholdValueArr = [0, 10, 20]
	return (
		<div className="box-settings__child display--flex__flex--end--center">
			<label>Occupancy Threshold</label>
			<Dropdown
				noArrow={true}
				className="box-settings__child__dropdown"
				header={
					<React.Fragment>
						{`${occupancyThreshold !== 0 ? `>=${occupancyThreshold}` : `>${occupancyThreshold}`} %`}
						<i className="material-icons">keyboard_arrow_down</i>
					</React.Fragment>
				}
				toggleable={editable}
			>
				{thresholdValueArr.map(value => {
					return (
						<React.Fragment key={value}>
							<DropdownItem style={{ textAlign: "center" }}>
								<div onClick={() => {
									setOccupancyThreshold(value);
									handleUpdateThreshold()
								}}>
									{`${value !== 0 ? `>=${value}` : `>${value}`} %`}
								</div>
							</DropdownItem>
						</React.Fragment>
					)
				})
				}
			</Dropdown>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/pages/defaultsettings/card.jsx